import { Attrs, MinzeElement } from 'minze'

export interface LvcHomeIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcHomeIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 33],
    ['data-height', 32],
  ]
  html = () => `
    <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.31545 13C7.21089 16.2857 7.10633 19.5714 7 22.8572C8.59499 23.0267 11.4713 23.0267 12.4017 22.9532C12.6321 22.9344 12.6782 18.9083 12.648 17.369C14.3246 17.3106 14.2306 17.2503 15.9071 17.1919C16.0135 17.1882 16.1287 17.1882 16.2137 17.2541C16.3165 17.337 16.3396 17.4896 16.3537 17.6253C16.5132 19.1701 16.6727 20.715 16.834 22.2599C16.8517 22.437 16.8801 22.6311 17.0077 22.7441C17.1282 22.8515 17.3019 22.8515 17.4578 22.8459C18.6771 22.8063 20.7807 22.7667 22 22.7272C21.8263 19.6656 22 17.0054 21.8937 13.5388" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.13745 13.105C6.50152 9.89923 10.041 6.89303 13.7335 4.1003C17.8897 6.57322 20.7814 9.35924 24.9376 11.8302" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `
  css = () => `
    
  `
}
